export const APP = {
  MONTHS: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
};
